export type CTFJson = {
  content: CTFJson[];
  marks: { type: string }[];
  data: { uri: string };
  nodeType: string;
  value: string;
};

export function parseNodeContentIntoHtml(contentfullJson: CTFJson): string {
  function renderNode(node: CTFJson): string {
    switch (node.nodeType) {
      case 'document':
        return node.content.map(renderNode).join('');
      case 'heading-1':
        return `<h1>${node.content.map(renderNode).join('')}</h1>`;
      case 'heading-2':
        return `<h2>${node.content.map(renderNode).join('')}</h2>`;
      case 'heading-3':
        return `<h3>${node.content.map(renderNode).join('')}</h3>`;
      case 'heading-4':
        return `<h4>${node.content.map(renderNode).join('')}</h4>`;
      case 'heading-5':
        return `<h5>${node.content.map(renderNode).join('')}</h5>`;
      case 'text':
        return node.marks && node.marks.some((mark: { type: string }) => mark.type === 'bold') ?
            `<strong>${node.value}</strong>`
          : node.value;

      case 'hyperlink':
        return `<a href="${node.data.uri}">${node.content.map(renderNode).join('')}</a>`;

      case 'paragraph':
        return `<p>${node.content.map(renderNode).join('')}</p>`;

      case 'list-item':
        return `<li>${node.content.map(renderNode).join('')}</li>`;

      case 'unordered-list':
        return `<ul>${node.content.map(renderNode).join('')}</ul>`;

      case 'ordered-list':
        return `<ol>${node.content.map(renderNode).join('')}</ol>`;

      default:
        return `type: ${node.nodeType}`;
    }
  }

  return renderNode(contentfullJson);
}
